module.exports = __webpack_public_path__ + "static/media/loader.27ca61a6.svg";